export const setBlockEntries = (state, entries) => {
    state.blockEntries = { ...entries };
};

export const setBlockError = (state, error) => {
    state.blockError = error;
}
